module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-5starlotto.d655fc77.png";